<template>
  <div class="result-vote">
    <div class="hero-images">
      <img src="@images/top/389650ab514d27b996578aa1b32116fc.png">
    </div>
    <animation-button class="result-button">
      <div class="btn-outer" @click="resultBtnClick()">
        <img class="text"
          :src="require(`@images/top/${$route.params.lang}/btn_result-text.png`)"
          :alt="$t('result.btn001')"
        >
      </div>
    </animation-button>
    <section class="to-official">
      <BtnOfficial />
    </section>
  </div>
</template>
<script>
import AnimationButton from '@components/global/animation-button.vue'
import BtnOfficial from '@components/global/button-official.vue'
import localeTop from '@locales/top'

export default {
  $messages: localeTop,
  components: {
    AnimationButton,
    BtnOfficial,
  },
  methods: {
    resultBtnClick(){
      this.$router.push(`/${this.$route.params.lang}/results`)
      window.scrollTo(0, 0)
    }
  }
}
</script>
<style lang="scss" scoped>
.result-vote {
  > .hero-images {
    margin-top: -20px;
  }
  > .result-button {
    margin-top: -90px;
    .btn-outer {
      position: relative;
      z-index: 10;
      display: flex;
      justify-content: center;
      align-items: center;
      width: 556px;
      height: 198px;
      margin: 0 auto;
      padding: 0;
      background-image: url(#{$img-path}top/btn_result.png);
      background-repeat: no-repeat;
      background-color: transparent;
      background-position: 50% 0;
      background-size: auto 100%;
      @include tap-event();
    }
  }
  > .to-official {
    margin: 40px 0 80px 0;
  }
}
</style>